import request from '@/utils/request'

/**
 * 查询his应用版本管理信息列表
 * @param {*} params
 * @returns
 */
export const findHisApplyManagePage = (params) => {
  return request({
    method: 'GET',
    url: '/tools/v1/hisApplyManage/findHisApplyManagePage',
    params
  })
}

/**
 * 新增his应用版本
 * @param {*} data
 * @returns
 */
export const insertHisApply = (data) => {
  return request({
    method: 'POST',
    url: '/tools/v1/hisApplyManage/insertHisApply',
    data
  })
}

/**
 * 修改his应用版本
 * @param {*} data
 * @returns
 */
export const updateHisApply = (data) => {
  return request({
    method: 'POST',
    url: '/tools/v1/hisApplyManage/updateHisApply',
    data
  })
}

/**
 * 删除his应用版本
 * @param {*} data
 * @returns
 */
export const deleteHisApply = (data) => {
  return request({
    method: 'DELETE',
    url: '/tools/v1/hisApplyManage/deleteHisApply',
    data
  })
}

/**
 * 复制his应用版本
 * @param {*} data
 * @returns
 */
export const copyHisApply = (data) => {
  return request({
    method: 'POST',
    url: '/tools/v1/hisApplyManage/copyHisApply',
    data
  })
}

/**
 * 根据id获取信息
 * @param {*} id
 * @returns
 */
export const getHisApplyManageById = (id) => {
  return request({
    method: 'GET',
    url: `/tools/v1/hisApplyManage/${id}`
  })
}

/**
 * 查询his应用版本管理信息列表
 * @param {*} params
 * @returns
 */
export const findHisApplyPlugManagePage = (params) => {
  return request({
    method: 'GET',
    url: '/tools/v1/hisApplyPlug/findHisApplyManagePage',
    params
  })
}

/**
 * 新增his应用版本插件
 * @param {*} data
 * @returns
 */
export const insertHisApplyPlug = (data) => {
  return request({
    method: 'POST',
    url: '/tools/v1/hisApplyPlug/insertHisApplyPlug',
    data
  })
}

/**
 * 根据应用标识预览某个应用下的插件
 * @param {*} id
 * @returns
 */
export const previewByAppId = (id) => {
  return request({
    url: `/tools/v1/hisApplyPlug/previewByAppId/${id}`
  })
}

/**
 * 修改his应用版本插件
 * @param {*} data
 * @returns
 */
export const updateHisApplyPlug = (data) => {
  return request({
    method: 'POST',
    url: '/tools/v1/hisApplyPlug/updateHisApplyPlug',
    data
  })
}

/**
 * 查询his应用配置信息列表
 * @param {*} params
 * @returns
 */
export const findHisApplyConfigPage = (params) => {
  return request({
    url: '/tools/v1/hisApplyConfig/findHisApplyConfigPage',
    params
  })
}

/**
 * 新增his应用配置
 * @param {*} data
 * @returns
 */
export const insertHisApplyConfig = (data) => {
  return request({
    method: 'POST',
    url: '/tools/v1/hisApplyConfig/insertHisApplyConfig',
    data
  })
}

/**
 * 修改his应用配置
 * @param {*} data
 * @returns
 */
export const updateHisApplyConfig = (data) => {
  return request({
    method: 'POST',
    url: '/tools/v1/hisApplyConfig/updateHisApplyConfig',
    data
  })
}

/**
 * 删除his应用配置
 * @returns
 */
export const deleteHisApplyById = (data) => {
  return request({
    method: 'DELETE',
    url: '/tools/v1/hisApplyConfig/deleteHisApplyById',
    data
  })
}

/**
 * 上架下架his应用版本
 * @param {*} data
 * @returns
 */
export const updateHisApplyStatus = (data) => {
  return request({
    method: 'POST',
    url: '/tools/v1/hisApplyManage/updateHisApplyStatus',
    data
  })
}

/**
 * 删除
 * @param {*} id
 * @returns
 */
export const delHisApplyPlug = (id) => {
  return request({
    method: 'DELETE',
    url: `/tools/v1/hisApplyPlug/${id}`
  })
}
